import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Tabs,
  Tab,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
  CircularProgress,
  Paper,
  SvgIcon,
} from "@mui/material";
import {
  Info as InfoIcon,
  Close as CloseIcon,
  VideoLibrary as VideoLibraryIcon,
} from "@mui/icons-material";

import ModalXLogo from "../assets/ModalX_-orange_Icon.png";
import HeygenLogo from "../assets/Heygen/Heygen Logo.png";

import AvatarCreation from "../components/workspace/settingBar/HeyGenSettings.jsx/AvatarCreation/AvatarCreation";
import CaptionSettingsForHeygen from "../components/workspace/settingBar/HeyGenSettings.jsx/CaptionSettings";
import LanguageAndVoiceForHeygen from "../components/workspace/settingBar/HeyGenSettings.jsx/LanguageAndVoiceForHeygen";
import DimensionsSettings from "../components/workspace/settingBar/HeyGenSettings.jsx/DimensionsSettings";
import VideoTimeline from "../components/VideoEditor/VideoTimeline";
import Veo2Settings from "../components/VideoEditor/Veo2Settings";
import sourceUrl, { newSourceUrl } from "../api/Source.api";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile, toBlobURL } from "@ffmpeg/util";
import Background from "../components/workspace/settingBar/MultiAvatarVideoSettings/Background";
import { button_bg_color_for_New_Project } from "../constants/colors";
import { useWorkspace } from "../contexts/WorkspaceContext";
import VideoPreviewWindow from "../components/workspace/settingBar/MultiAvatarVideoSettings/VideoPreviewWindow";
import VideoCreationDialogForVeo from "../components/workspace/settingBar/MultiAvatarVideoSettings/VideoCreationDialogForVeo";
import { Timeline } from "../components/workspace/settingBar/MultiAvatarVideoSettings/TimeLineForVeoVideo";
import VideoCreationDialog from "../components/workspace/settingBar/MultiAvatarVideoSettings/VideoCreationDialog";
import CommonToast from "../components/Common_Components/CommonToast";


const PROVIDERS = {
  HEYGEN: "heygen",
  VEO2: "veo2",
};

const TRANSITIONS = [
  { value: "none", label: "None" },
  { value: "fade", label: "Fade" },
  { value: "dissolve", label: "Dissolve" },
  { value: "wipe", label: "Wipe" },
  { value: "slide", label: "Slide" },
  { value: "zoom", label: "Zoom" },
];

let Video4 = "https://dev-modalx-assets.s3.us-east-1.amazonaws.com/output/shaban@modalx.ai/284/622/video_20250916_041215.mp4"
// let Video1 = "https://dev-modalx-assets.s3.us-east-1.amazonaws.com/output/shaban@modalx.ai/284/622/video_20250916_041215.mp4"
let Video3 = "https://uploads.dev.modalx.ai/output/files/e0fd5ccc-702b-456a-b271-f952045bf76d.mp4"
let Video2 = "https://uploads.dev.modalx.ai/output/files/9fe72940-d09a-4072-9dce-d099620fadaa.mp4"
let Video1 = "https://uploads.dev.modalx.ai/output/files/9e0b62e8-7aae-4f03-a40f-6c90bad04856.mp4"

function GradientAIIcon() {
  return (
    <SvgIcon>
      <defs>
        <linearGradient id="aiGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#00a1ff" />
          <stop offset="100%" stopColor="#ff00fb" />
        </linearGradient>
      </defs>

      {/* First path */}
      <path
        d="M19.03 3.56c-1.67-1.39-3.74-2.3-6.03-2.51v2.01c1.73.19 3.31.88 4.61 1.92zM11 3.06V1.05c-2.29.2-4.36 1.12-6.03 2.51l1.42 1.42C7.69 3.94 9.27 3.25 11 3.06M4.98 6.39 3.56 4.97C2.17 6.64 1.26 8.71 1.05 11h2.01c.19-1.73.88-3.31 1.92-4.61M20.94 11h2.01c-.21-2.29-1.12-4.36-2.51-6.03l-1.42 1.42c1.04 1.3 1.73 2.88 1.92 4.61M7 12l3.44 1.56L12 17l1.56-3.44L17 12l-3.44-1.56L12 7l-1.56 3.44z"
        fill="url(#aiGradient)"
      />

      {/* Second path */}
      <path
        d="M12 21c-3.11 0-5.85-1.59-7.46-4H7v-2H1v6h2v-2.7c1.99 2.84 5.27 4.7 9 4.7 4.87 0 9-3.17 10.44-7.56l-1.96-.45C19.25 18.48 15.92 21 12 21"
        fill="url(#aiGradient)"
      />
    </SvgIcon>
  );
}

const EnhanceScriptAPI = async (text, provider = PROVIDERS.HEYGEN) => {
  const token = localStorage.getItem("token");
  const isLoggedIn = localStorage.getItem("isLoggedIn");

  const endpoint =
    provider === PROVIDERS.VEO2
      ? "/v1/video/motion/scripts/enhance"
      : "/v1/video/avatar/scripts/enhance";

  try {
    const response = await fetch(`${newSourceUrl}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(isLoggedIn && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify({
        script: text,
      }),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.message || `HTTP ${response.status}`);
    }

    const data = await response.json();
    return data.data.enhanced_script;
  } catch (err) {
    return text;
  }
};

const generateVeo2Video = async (prompt, veoVideoResolution, veoVideoPeopleAndFaces) => {
  const token = localStorage.getItem("token");
  const isLoggedIn = localStorage.getItem("isLoggedIn");

  try {
    const response = await fetch(`${newSourceUrl}/v1/video/motion-graphic/generate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(isLoggedIn && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify({
        prompt: prompt,
        aspect_ratio: veoVideoResolution?.ratio ? veoVideoResolution?.ratio : "16:9",
        negative_prompt: "blurry, low quality",
        person_generation: veoVideoPeopleAndFaces ? veoVideoPeopleAndFaces : "allow_person",
        duration_seconds: 8,
        enhance_prompt: true
      }),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.message || `HTTP ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    throw err;
  }
};

const LeftPanel = ({ activeProvider, onProviderChange }) => {
  return (
    <Paper
      elevation={3}
      sx={{
        position: { xs: "fixed", sm: "fixed" },
        left: 0,
        top: { xs: "auto", sm: 0 },
        bottom: { xs: 0, sm: "auto" },
        width: { xs: "100%", sm: "60px", md: "4rem" },
        height: { xs: "60px", sm: "100vh" },
        bgcolor: "#282D51",
        color: "white",
        p: { xs: 1, md: 2 },
        overflow: "hidden",
        display: "flex",
        flexDirection: { xs: "row", sm: "column" },
        alignItems: "center",
        justifyContent: { xs: "space-around", sm: "flex-start" },
        zIndex: 100,
      }}
    >
      <Box
        sx={{
          display: { xs: "flex", sm: "block" },
          alignItems: "center",
        }}
      >
        <img
          src={ModalXLogo}
          style={{ width: 40, height: 40 }}
          alt="ModalX Logo"
        />
      </Box>

      <Box
        sx={{
          position: { xs: "relative", sm: "absolute" },
          top: { xs: "auto", sm: "50%" },
          transform: { xs: "none", sm: "translateY(-50%)" },
          display: "flex",
          flexDirection: { xs: "row", sm: "column" },
          gap: { xs: 2, sm: 3 },
        }}
      >
        <Tooltip title="Avatar Video Generation" placement="right">
          <IconButton
            onClick={() => onProviderChange(PROVIDERS.HEYGEN)}
            sx={{
              width: { xs: 44, sm: 40, md: 48 },
              height: { xs: 44, sm: 40, md: 48 },
              border:
                activeProvider === PROVIDERS.HEYGEN
                  ? "2px solid #ffffff"
                  : "1px solid #CAC4D0",
              borderRadius: 2,
              bgcolor:
                activeProvider === PROVIDERS.HEYGEN
                  ? "#1F233E"
                  : "transparent",
              "&:hover": {
                bgcolor: "#373E6D",
                borderColor: "#ffffff",
              },
            }}
          >
            <img
              src={HeygenLogo}
              style={{ width: 30, height: 15 }}
              alt="HeyGen"
            />
          </IconButton>
        </Tooltip> 

        <Tooltip title="Voice-over Video Generation" placement="right">
          <IconButton
            onClick={() => onProviderChange(PROVIDERS.VEO2)}
            sx={{
              width: { xs: 44, sm: 40, md: 48 },
              height: { xs: 44, sm: 40, md: 48 },
              border:
                activeProvider === PROVIDERS.VEO2
                  ? "2px solid #ffffff"
                  : "1px solid #CAC4D0",
              borderRadius: 2,
              bgcolor:
                activeProvider === PROVIDERS.VEO2
                  ? "#1F233E"
                  : "transparent",
              "&:hover": {
                bgcolor: "#373E6D",
                borderColor: "#ffffff",
              },
            }}
          >
            <VideoLibraryIcon
              sx={{
                color: activeProvider === PROVIDERS.VEO2 ? "#ffffff" : "#CAC4D0",
                fontSize: 28,
              }}
            />
          </IconButton>
        </Tooltip>
      </Box>
    </Paper>
  );
};

const ScriptPanel = ({
  script,
  onScriptChange,
  onAIEnhance,
  isEnhancing,
  provider,
  setVeo2Prompt,
  veo2Prompt
}) => {
  const charCount = script.length;
  const maxChars = provider === PROVIDERS.VEO2 ? 2000 : 2000;
  const title = provider === PROVIDERS.VEO2 ? "Prompt" : "Script";
  const placeholder =
    provider === PROVIDERS.VEO2
      ? "Describe the video you want to generate..."
      : "Enter your script here...";

  // Use different styling based on provider
  const panelStyles = {
          // position: { xs: "relative", sm: "absolute" },
          // left: { xs: 0, sm: "4.2rem" },
          // top: {
          //   xs: 0,
          //   sm: "calc(((45vw * 9) / 16) + 30px)",
          //   md: "calc(((40vw * 9) / 16) + 30px)",
          //   lg: "calc(((33vw * 9) / 16) + 30px)",
          // },
          bottom: { xs: "auto", sm: "calc(19vh + 10px)" },
          width: "100%",
          height:"255px",
          bgcolor: "#1F233E",
          p: { xs: 1.5, sm: 1 },
          mb: { xs: 2, sm: 0 },
          borderRadius: 2,
          overflow: "hidden",
        }

  return (
    <Paper elevation={2} sx={panelStyles}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            sx={{ color: "#ffffff", fontWeight: "bold", fontSize: "15px" }}
          >
            {title}
          </Typography>
          {provider === PROVIDERS.VEO2 && (
            <Tooltip
              title={
                <Box>
                  <Typography
                    variant="caption"
                    sx={{ display: "block", mb: 0.5 }}
                  >
                    • Be specific about camera movements and angles
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ display: "block", mb: 0.5 }}
                  >
                    • Describe lighting and atmosphere for better results
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ display: "block", mb: 0.5 }}
                  >
                    • Include details about timing and pacing
                  </Typography>
                  <Typography variant="caption" sx={{ display: "block" }}>
                    • Mention specific visual styles or references
                  </Typography>
                </Box>
              }
              placement="right"
              arrow
            >
              <InfoIcon
                sx={{
                  fontSize: 18,
                  color: "#8e8e8e",
                  cursor: "help",
                  "&:hover": {
                    color: "#4CAF50",
                  },
                }}
              />
            </Tooltip>
          )}
        </Box>
        <Button
          startIcon={
            isEnhancing ? <CircularProgress size={16} /> : <GradientAIIcon />
          }
          onClick={onAIEnhance}
          disabled={isEnhancing || !script.trim()}
          sx={{
            color: "white",
            "&:hover": {
              background:
                "linear-gradient(45deg, rgba(230, 0, 226, 0.2), rgba(0, 145, 230, 0.2))",
            },
            "&:disabled": {
              opacity: 0.8,
            },
          }}
        >
          <Typography sx={{ fontSize: "12px", color: "white" }}>
            {isEnhancing ? "Enhancing..." : "AI Enhance"}
          </Typography>
        </Button>
      </Box>

      <TextField
        multiline
        rows={provider === PROVIDERS.HEYGEN ? 7 : 5}
        fullWidth
        value={ provider === PROVIDERS.HEYGEN ? script : veo2Prompt}
        onChange={ provider === PROVIDERS.HEYGEN ? (e) => onScriptChange(e.target.value) : (e)=> setVeo2Prompt(e.target.value)}
        placeholder={placeholder}
        inputProps={{ maxLength: maxChars }}
        sx={{
          height: {
            xs: "calc(100% - 65px)",
            sm:
              provider === PROVIDERS.HEYGEN
                ? "calc(100% - 50px)"
                : "calc(100% - 60px)",
          },
          "& .MuiOutlinedInput-root": {
            height: "100%",
            bgcolor: "transparent",
            color: "#b1b1b1",
            padding: provider === PROVIDERS.VEO2 ? "12px" : "12px",
            "& fieldset": {
              borderColor: "#373E6D",
            },
            "&:hover fieldset": {
              borderColor: "#555",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#00a1ff",
            },
          },
          "& .MuiInputBase-input": {
            fontSize: { xs: "14px", md: "16px" },
            fontFamily: "Jura, sans-serif",
            fontWeight: "bold",
            padding: provider === PROVIDERS.VEO2 ? "0" : "0",
            overflow: "auto !important",
            scrollbarWidth: "thin",
            scrollbarColor: "#555 #1a1a1a",
            "&::-webkit-scrollbar": {
              width: "8px",
              height: "8px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#1a1a1a",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#555",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#666",
              },
            },
            "&::-webkit-scrollbar-corner": {
              backgroundColor: "#1a1a1a",
            },
          },
        }}
      />

      <Typography
        variant="caption"
        sx={{
          color: charCount > maxChars * 0.9 ? "#ff6b6b" : "#8e8e8e",
          float: "right",
        }}
      >
        {charCount}/{maxChars}
      </Typography>
    </Paper>
  );
};

const RightPanel = ({
  activeTab,
  onTabChange,
  timelineItemss,
  activeTimelineItems,
  items,
  caption,
  setCaption,
  width,
  setWidth,
  height,
  setHeight,
}) => {
  const renderTabContent = () => {
    switch (activeTab) {
      case "background":
        return (
          // <HeygenVideoBackground
          //   timelineItems={timelineItemss}
          //   activeTimelineItem={activeTimelineItems}
          //   color={items[activeTimelineItems].background}
          // />
          <Background/>
        );
      case "avatars":
        return (
          <AvatarCreation
            timelineItems={timelineItemss}
            activeTimelineItem={activeTimelineItems}
          />
        // <AvatarPage/>
        );
      case "voices":
        return (
          <LanguageAndVoiceForHeygen
            timelineItems={timelineItemss}
            activeTimelineItem={activeTimelineItems}
          />
        );
      case "settings":
        return (
          <div>
            <CaptionSettingsForHeygen
              //timelineItems={timelineItemss}
              //activeTimelineItem={activeTimelineItems}
              state={caption}
              setState={setCaption}
              //state={items[activeTimelineItems].caption}
            />
            <DimensionsSettings
              //timelineItems={timelineItemss}
              //activeTimelineItem={activeTimelineItems}
              //width={items[activeTimelineItems].width}
              //height={items[activeTimelineItems].height}
              width={width}
              setWidth={setWidth}
              height={height}
              setHeight={setHeight}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
    <Paper
      elevation={3}
      sx={{
        // position: { xs: "relative", sm: "absolute" },
        // left: { xs: 0, sm: 70 },
        // top: { xs: 0, sm: 400 },
        // width: { xs: "100%", sm: "100%", md: "100%" },
        height: { xs: "auto", sm: "44vh", md: "44vh" },
        minHeight: { xs: "470px", sm: "470px" },
        bgcolor: "#282D51",
        borderRadius: 2,
        overflow: "hidden",
        mb: { xs: 2, sm: 0 },
        border:"", 
        display: "flex",
        flexDirection:"row",
        marginTop:"32px"
        // marginLeft:"1.50rem"
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "#1a1d2e", display:"flex", flexDirection:"column",border:"" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection:"column",
            // alignItems: "center",
            // justifyContent: "space-between",
            border:"" 
          }}
        >
          <Tabs
            value={activeTab}
            onChange={(e, value) => onTabChange(value)}
            orientation="vertical"
            sx={{
              width:"174px",
              display:"flex",
              flexDirection:"column",
              marginLeft: "auto",
              marginRight: "auto",
              "& .MuiTab-root": {
                color: "#ccc",
                minHeight: { xs: 36, sm: 40 },
                fontSize: { xs: "0.75rem", sm: "0.9rem" },
                px: { xs: 0.5, sm: 1, md: 2 },
              },
              "& .Mui-selected": {
                  color: "#ffffff !important",
                  backgroundColor: "#282D51", // 🔥 Selected tab color
            },
            "& .MuiTabs-indicator": {
              display: "none", // 🔥 Hide the default blue indicator
            }
            }}
          >
            <Tab sx={{ borderBottom: "1px solid #CAC4D0", height:"117px", color:"#ffffff", fontFamily:"Inter", fontSize:"20px", fontStyle:"normal", fontWeight:400, lineHeight:"20px" }} label="BACKGROUND COLOR" value="background" />
            <Tab sx={{borderBottom: "1px solid #CAC4D0",height:"117px", color:"#ffffff", fontFamily:"Inter", fontSize:"20px", fontStyle:"normal", fontWeight:400, lineHeight:"20px" }}  label="Avatars" value="avatars" />
            <Tab sx={{borderBottom: "1px solid #CAC4D0",height:"117px", color:"#ffffff", fontFamily:"Inter", fontSize:"20px", fontStyle:"normal", fontWeight:400, lineHeight:"20px" }} label="Voices" value="voices" />
            <Tab sx={{height:"117px", color:"#ffffff", fontFamily:"Inter", fontSize:"20px", fontStyle:"normal", fontWeight:400, lineHeight:"20px" }} label="Settings" value="settings" />
          </Tabs>
        </Box>
      </Box>
      <Box sx={{overflow: "auto", p: 3, border:"", flex: 1,  }}>
        {renderTabContent()}
      </Box>
    </Paper>
    </>
  );
};

export default function VideoGenerate() {
  const navigate = useNavigate();
  const [activeProvider, setActiveProvider] = useState(PROVIDERS.HEYGEN);
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const [open, setOpen] = useState(false)
  const [content, setContent] = useState();
  const [iconType, setIconType] = useState('success');


  // Check authentication on component mount
  useEffect(() => {
    if (!isLoggedIn || isLoggedIn === "undefined") {
      // alert("Please login to access this feature");
      // navigate(-1); // Go back to previous page
      navigate("/")
      setOpen(true);
      setContent("Please login to access this feature")
      setIconType('error')
    }
  }, [isLoggedIn]);
  const [script, setScript] = useState(
    "Hey I will be talking about how we generate video with\nModalX, hope you like it."
  );
  const [caption, setCaption] = useState(false);
  const [videoWidth, setVideoWidth] = useState(1920);
  const [videoHeight, setVideoHeight] = useState(1080);

  const [videoTitle, setVideoTitle] = useState("");
  const [activeTab, setActiveTab] = useState("background");
  const [isEnhancing, setIsEnhancing] = useState(false);
  const [dailogMessage, setDailogMessage] = useState("Your video is being generated. This may take a few moments — please wait.");

  //Heygen Specific States
   const [heygenPrompt, setHeygenPrompt] = useState("");

  // Veo2 specific states
  const [veo2Prompt, setVeo2Prompt] = useState("");
  const [veo2PersonGeneration, setVeo2PersonGeneration] = useState(false);
  // const [veo2Videos, setVeo2Videos] = useState([{id:1,url:Video1, duration: 8, thumbnail : "https://drive.google.com/file/d/1MNNElyqVBUHofyO8dmO7yjtxJ9ozciR4/view?usp=sharing"},{id:2,url:Video2, duration: 8, thumbnail : "https://drive.google.com/file/d/1h79mPTuKK2wljf73b1W6XCq4Wf7T0oc1/view?usp=sharing"}]);
  const [veo2Transitions, setVeo2Transitions] = useState([]);
  const [ffmpegLoading, setFfmpegLoading] = useState(false);
  const [exportProgress, setExportProgress] = useState(0);
  const [exportSettings, setExportSettings] = useState(null);
  const {veo2Videos, setVeo2Videos} = useWorkspace()
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: "",
    message: "",
    onConfirm: null,
  });
  const [activeTimelineItem, setActiveTimelineItem] = useState(0);
  const [timelineItems, setTimelineItems] = useState([
    activeProvider == PROVIDERS.HEYGEN ?  {
      id: `timeline-${Date.now()}`,
      thumbnail:"https://files2.heygen.ai/avatar/v3/00de8c52f5884155997a643d9732e669_37110/preview_talk_3.webp",
      avatar: "Anja_sitting_sofa_front",
      talkingphoto: "",
      voice: "73c0b6a2e29d4d38aca41454bf58c955",
      script:
        "Hey I will be talking about how we generate video with\nModalX, hope you like it.",
      duration: 10,
      position: 0,
      //width: 1920,
      //height: 1080,
      //caption: false,
      background: "",
    }
    :
    {id:1,url:Video1, duration: 8, thumbnail : "https://drive.google.com/file/d/1MNNElyqVBUHofyO8dmO7yjtxJ9ozciR4/view?usp=sharing"}
  ]);
  const [loaded, setLoaded] = useState(false);

  // useEffect(()=>{
  //   setVeo2Videos([{id:1,url:Video1, duration: 8, thumbnail : "https://drive.google.com/file/d/1MNNElyqVBUHofyO8dmO7yjtxJ9ozciR4/view?usp=sharing"},{id:2,url:Video2, duration: 8, thumbnail : "https://drive.google.com/file/d/1h79mPTuKK2wljf73b1W6XCq4Wf7T0oc1/view?usp=sharing"}])
  // },[])

  // console.log("veo2Prompt",veo2Prompt)

  useEffect(() => {
    const current = timelineItems[activeTimelineItem];
    if (current) {
      setScript(current.script);
    }
  }, [activeTimelineItem]);

  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogForVeo, setOpenDialogForVeo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [isLoadingScript, setIsLoadingScript] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [progress, setProgress] = useState(0);
  const [mergedVideoUrl, setMergedVideoUrl] = useState(null);
  const [error, setError] = useState('');
  const [selectedTransition, setSelectedTransition] = useState("none");
  const { veoVideoPeopleAndFaces, veoVideoResolution} = useWorkspace()

   const handleCloseToast = () => {
    setOpen(false);
  };


let ffmpeg;
let ffmpegLoaded = false;

const initializeFFmpeg = async () => {
  if (!ffmpegLoaded) {
    ffmpeg =new FFmpeg({
      log: true,
      corePath: 'https://unpkg.com/@ffmpeg/core@0.8.5/dist/ffmpeg-core.js',
      progress: ({ ratio }) => console.log(`Progress: ${Math.round(ratio * 100)}%`),
    });

    await ffmpeg.load();
    ffmpegLoaded = true;
  }
};

  const handleScriptChange = (newScript) => {
    setScript(newScript);
    setTimelineItems((prevItems) => {
      const items = [...prevItems];

      items[activeTimelineItem] = {
        ...items[activeTimelineItem],
        script: newScript,
      };

      return items;
    });
  };
  const handleAIEnhance = async () => {
    const textToEnhance =
      activeProvider === PROVIDERS.VEO2 ? veo2Prompt : script;
    if (!textToEnhance.trim()) return;
    setIsEnhancing(true);

    try {
      const enhancedText = await EnhanceScriptAPI(
        textToEnhance,
        activeProvider
      );
      if (activeProvider === PROVIDERS.VEO2) {
        setVeo2Prompt(enhancedText);
      } else {
        handleScriptChange(enhancedText);
      }
      showSnackbar("Enhanced successfully!", "success");
    } catch (error) {
      showSnackbar("Failed to enhance. Please try again", "error");
    } finally {
      setIsEnhancing(false);
    }
  };

  const handleVeo2Generate = async () => {
    if (!veo2Prompt.trim()) {
      showSnackbar("Please enter a prompt for video generation", "warning");
      return;
    }

    setLoading(true);
    setOpenDialogForVeo(true)
    try {
      const videoData = await generateVeo2Video(
        veo2Prompt,
        veoVideoResolution,
        veoVideoPeopleAndFaces,
      );
      const newVideo = {
        id: `veo2-${Date.now()}`,
        url: videoData.data.video_url,
        duration: 8
      };
      // setVeo2Videos([...veo2Videos, newVideo]);
      setVeo2Videos(prev => (prev ? [...prev, newVideo] : [newVideo]));
      showSnackbar("Video generated successfully!", "success");
      setVeo2Prompt("")
      setVideoTitle("")
    } catch (error) {
      showSnackbar("Failed to generate video: " + error.message, "error");
    } finally {
      setLoading(false);
      setOpenDialogForVeo(false)
    }
  };

  const handleVeo2AddTransition = (index, type, duration) => {
    const updatedTransitions = [...veo2Transitions];
    updatedTransitions[index] = { type, duration };
    setVeo2Transitions(updatedTransitions);
    showSnackbar(`${type} transition added`, "success");
  };

  const handleTimelineReorder = (sourceIndex, destinationIndex) => {
    const newItems = Array.from(timelineItems);
    const [reorderedItem] = newItems.splice(sourceIndex, 1);
    newItems.splice(destinationIndex, 0, reorderedItem);

    const updatedItems = newItems.map((item, index) => ({
      ...item,
      position: index,
    }));

    setTimelineItems(updatedItems);
  };

  const handleDeleteTimelineItem = (itemId) => {
    if (timelineItems?.length === 1) {
      const newItem = {
        id: `timeline-${Date.now()}`,
        thumbnail:"https://files2.heygen.ai/avatar/v3/00de8c52f5884155997a643d9732e669_37110/preview_talk_3.webp",
        avatar: "Anja_sitting_sofa_front",
        talkingphoto: "",
        voice: "73c0b6a2e29d4d38aca41454bf58c955",
        script:
          "Hey I will be talking about how we generate video with\nModalX, hope you like it.",
        duration: 10,
        position: 0,
        //width: 1920,
        //height: 1080,
        //caption: false,
        background: "",
      };
      setTimelineItems([newItem]);
      setActiveTimelineItem(0);
    } else if (timelineItems[activeTimelineItem].id >= itemId) {
      const prevIndex =
        activeTimelineItem === 0
          ? timelineItems.length === 1
            ? -1
            : 0
          : activeTimelineItem - 1;
      setActiveTimelineItem(prevIndex);
    }
    setTimelineItems((prev) => prev.filter((item) => item.id !== itemId));
    showSnackbar("Timeline item removed", "info");
  };

  const handleAddToTimeline = () => {
    const newItem = {
      id: `timeline-${Date.now()}`,
      thumbnail:
        "https://files2.heygen.ai/avatar/v3/00de8c52f5884155997a643d9732e669_37110/preview_talk_3.webp",
      avatar: "Anja_sitting_sofa_front",
      talkingphoto: "",
      voice: "73c0b6a2e29d4d38aca41454bf58c955",
      script:
        "Hey I will be talking about how we generate video with\nModalX, hope you like it.",
      duration: 10,
      position: timelineItems.length,
      //width: 1920,
      //height: 1080,
      //caption: false,
      background: "",
    };
    setActiveTimelineItem(newItem.position);
    setTimelineItems((prev) => [...prev, newItem]);
  };

  const handleCreate = async () => {
    if (timelineItems.length === 0) {
      showSnackbar(
        "Please add items to the timeline before creating",
        "warning"
      );
      return;
    }

    const emptyIndex = timelineItems.findIndex(
      (item) => item.script.trim().length === 0
    );

    if (emptyIndex !== -1) {
      showSnackbar(
        `Please add a script on Video ${emptyIndex + 1} before creating`,
        "warning"
      );
      return;
    }

    setOpenDialog(true);
    // showConfirmDialog(
    //   "Create Video",
    //   "Are you ready to create your video? This process may take a few minutes.",
    //   async () => {
    //     showSnackbar(
    //       "Video creation started! You will be notified when ready.",
    //       "success"
    //     );
    //     await new Promise((resolve) => setTimeout(resolve, 20000));
    //     console.log("Creating video with:", {
    //       videoTitle,
    //       timelineItems,
    //       totalDuration: timelineItems.reduce(
    //         (sum, item) => sum + item.duration,
    //         0
    //       ),
    //     });
    //   }
    // );
  };

  const handleCancel = () => {
    showConfirmDialog(
      "Cancel Video Creation",
      "Are you sure you want to cancel? All changes will be lost.",
      () => {
        // Reset all states
        setScript(
          "Hey I will be talking about how we generate video with\nModalX, hope you like it."
        );
        setVeo2Prompt("");
        setVeo2Videos([]);
        setVeo2Transitions([]);
        setVideoTitle("Video Title");
        setTimelineItems([
          {
            id: `timeline-${Date.now()}`,
            thumbnail:
              "https://files2.heygen.ai/avatar/v3/00de8c52f5884155997a643d9732e669_37110/preview_talk_3.webp",
            avatar: "Anja_sitting_sofa_front",
            talkingphoto: "",
            voice: "73c0b6a2e29d4d38aca41454bf58c955",
            script:
              "Hey I will be talking about how we generate video with\nModalX, hope you like it.",
            duration: 10,
            position: 0,
            background: "",
          },
        ]);
        setActiveTab("background");
        showSnackbar("Video creation cancelled", "info");
        // Navigate back to the previous page
        // navigate("/workspace");
        window.location.replace("/workspace");
      }
    );
  };

  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };
  const showConfirmDialog = (title, message, onConfirm) => {
    setConfirmDialog({ open: true, title, message, onConfirm });
  };

// Export final video function
const ExportFinalVideo = async (videos, transitionType, onProgress) => {
  setFfmpegLoading(true);
  setOpenDialogForVeo(true);
  setVideoTitle("Exporting Video");
  setFfmpegLoading("Merging videos with fast transitions...");
  
  try {
    const ff = await loadFFmpeg();
    
    ff.on("progress", ({ progress }) => {
      if (onProgress) onProgress(Math.min(progress * 100, 100));
    });

    console.log("Processing video files for fast merge with transitions...");

    const videoDurations = [];
    
    // OPTIMIZATION: Process files more efficiently
    const filePromises = videos.map(async (video, i) => {
      let fileData;
      
      if (isBlobUrl(video.url)) {
        const file = await blobUrlToFile(video.url);
        fileData = await fetchFile(file);
      } else {
        fileData = await fetchFile(video.url);
      }
      
      await ff.writeFile(`input${i}.mp4`, fileData);
      videoDurations.push(video.duration || 5);
    });

    await Promise.all(filePromises);

    // Use optimized transition filter
    const filterComplex = generateTransitionFilter(videos.length, transitionType, videoDurations);
    console.log("Using fast transition filter:", filterComplex);

    // FAST COMMAND WITH TRANSITIONS
    const command = [];
    
    // Add input files
    for (let i = 0; i < videos.length; i++) {
      command.push("-i", `input${i}.mp4`);
    }

    // OPTIMIZED SETTINGS FOR SPEED + TRANSITIONS
    command.push(
      "-filter_complex", 
      filterComplex,
      "-map", "[out]",
      "-c:v", "libx264",
      "-preset", "veryfast", // Fast but better than ultrafast for transitions
      "-crf", "24", // Good balance of speed and quality
      "-movflags", "+faststart",
      "-threads", "4", // More threads for parallel processing
      "-x264-params", "scenecut=0:bframes=0", // Disable complex features
      "-an", // No audio for faster processing
      "-y",
      "output.mp4"
    );

    console.log("Executing fast FFmpeg command with transitions...");
    await ff.exec(command);

    const data = await ff.readFile("output.mp4");
    const finalBlob = new Blob([data], { type: "video/mp4" });
    
    if (finalBlob.size === 0) {
      throw new Error("Output video is empty");
    }
    
    downloadVideo(finalBlob, "final_merged_video.mp4");
    
    return finalBlob;
    
  } catch (error) {
    console.error("Fast export with transitions failed:", error);
    throw error;
  } finally {
    setFfmpegLoading(false);
    setOpenDialogForVeo(false);
  }
};


// Generate filter complex based on transition type
const generateTransitionFilter = (videoCount, transitionType, durations = []) => {
  if (videoCount === 1) return "[0:v]format=yuv420p[out]";
  
  // Use provided durations or default to 5 seconds
  const videoDurations = durations?.length === videoCount ? durations : Array(videoCount).fill(5);
  
  switch (transitionType) {
    case "none":
      return generateNoTransition(videoCount);
    
    case "fade":
      return generateFadeTransition(videoCount, videoDurations);
    
    case "fadeblack":
      return generateFadeBlackTransition(videoCount, videoDurations);
    
    case "fadewhite":
      return generateFadeWhiteTransition(videoCount, videoDurations);
    
    case "distance":
      return generateDistanceTransition(videoCount, videoDurations);
    
    case "wipeleft":
      return generateWipeLeftTransition(videoCount, videoDurations);
    
    case "wiperight":
      return generateWipeRightTransition(videoCount, videoDurations);
    
    case "wipeup":
      return generateWipeUpTransition(videoCount, videoDurations);
    
    case "wipedown":
      return generateWipeDownTransition(videoCount, videoDurations);
    
    case "slideleft":
      return generateSlideLeftTransition(videoCount, videoDurations);
    
    case "slideright":
      return generateSlideRightTransition(videoCount, videoDurations);
    
    case "slideup":
      return generateSlideUpTransition(videoCount, videoDurations);
    
    case "slidedown":
      return generateSlideDownTransition(videoCount, videoDurations);
    
    case "smoothleft":
      return generateSmoothLeftTransition(videoCount, videoDurations);
    
    case "smoothright":
      return generateSmoothRightTransition(videoCount, videoDurations);
    
    case "smoothup":
      return generateSmoothUpTransition(videoCount, videoDurations);
    
    case "smoothdown":
      return generateSmoothDownTransition(videoCount, videoDurations);
    
    default:
      return generateNoTransition(videoCount);
  }
};

// Base transition function
const generateNoTransition = (videoCount) => {
  let inputs = "";
  for (let i = 0; i < videoCount; i++) {
    inputs += `[${i}:v]`;
  }
  return `${inputs}concat=n=${videoCount}:v=1[out]`;
};

// Fade Transitions
const generateFadeTransition = (videoCount, durations) => {
  let filters = [];
  const fadeDuration = 1.0;
  
  for (let i = 0; i < videoCount; i++) {
    const duration = durations[i];
    
    if (i === 0) {
      filters.push(`[${i}:v]format=yuv420p,trim=duration=${duration},fade=t=out:st=${duration - fadeDuration}:d=${fadeDuration}[v${i}]`);
    } else if (i === videoCount - 1) {
      filters.push(`[${i}:v]format=yuv420p,trim=duration=${duration},fade=t=in:st=0:d=${fadeDuration}[v${i}]`);
    } else {
      filters.push(`[${i}:v]format=yuv420p,trim=duration=${duration},fade=t=in:st=0:d=${fadeDuration},fade=t=out:st=${duration - fadeDuration}:d=${fadeDuration}[v${i}]`);
    }
  }
  
  let concatInputs = "";
  for (let i = 0; i < videoCount; i++) {
    concatInputs += `[v${i}]`;
  }
  filters.push(`${concatInputs}concat=n=${videoCount}:v=1[out]`);
  
  return filters.join(';');
};

const generateFadeBlackTransition = (videoCount, durations) => {
  let filters = [];
  const fadeDuration = 1.0;
  
  for (let i = 0; i < videoCount; i++) {
    const duration = durations[i];
    
    if (i === 0) {
      filters.push(`[${i}:v]format=yuv420p,trim=duration=${duration},fade=t=out:st=${duration - fadeDuration}:d=${fadeDuration}:color=black[v${i}]`);
    } else if (i === videoCount - 1) {
      filters.push(`[${i}:v]format=yuv420p,trim=duration=${duration},fade=t=in:st=0:d=${fadeDuration}:color=black[v${i}]`);
    } else {
      filters.push(`[${i}:v]format=yuv420p,trim=duration=${duration},fade=t=in:st=0:d=${fadeDuration}:color=black,fade=t=out:st=${duration - fadeDuration}:d=${fadeDuration}:color=black[v${i}]`);
    }
  }
  
  let concatInputs = "";
  for (let i = 0; i < videoCount; i++) {
    concatInputs += `[v${i}]`;
  }
  filters.push(`${concatInputs}concat=n=${videoCount}:v=1[out]`);
  
  return filters.join(';');
};

const generateFadeWhiteTransition = (videoCount, durations) => {
  let filters = [];
  const fadeDuration = 1.0;
  
  for (let i = 0; i < videoCount; i++) {
    const duration = durations[i];
    
    if (i === 0) {
      filters.push(`[${i}:v]format=yuv420p,trim=duration=${duration},fade=t=out:st=${duration - fadeDuration}:d=${fadeDuration}:color=white[v${i}]`);
    } else if (i === videoCount - 1) {
      filters.push(`[${i}:v]format=yuv420p,trim=duration=${duration},fade=t=in:st=0:d=${fadeDuration}:color=white[v${i}]`);
    } else {
      filters.push(`[${i}:v]format=yuv420p,trim=duration=${duration},fade=t=in:st=0:d=${fadeDuration}:color=white,fade=t=out:st=${duration - fadeDuration}:d=${fadeDuration}:color=white[v${i}]`);
    }
  }
  
  let concatInputs = "";
  for (let i = 0; i < videoCount; i++) {
    concatInputs += `[v${i}]`;
  }
  filters.push(`${concatInputs}concat=n=${videoCount}:v=1[out]`);
  
  return filters.join(';');
};

// Distance Transition (Zoom + Fade)
const generateDistanceTransition = (videoCount, durations) => {
  let filters = [];
  const transitionDuration = 1.0;
  
  for (let i = 0; i < videoCount; i++) {
    const duration = durations[i];
    
    if (i === 0) {
      filters.push(`[${i}:v]format=yuv420p,trim=duration=${duration},zoompan=z='min(zoom+0.0015,1.5)':d=1:fps=25,fade=t=out:st=${duration - transitionDuration}:d=${transitionDuration}[v${i}]`);
    } else if (i === videoCount - 1) {
      filters.push(`[${i}:v]format=yuv420p,trim=duration=${duration},fade=t=in:st=0:d=${transitionDuration},zoompan=z='if(lte(zoom,1.0),1.5,max(1.001,zoom-0.0015))':d=1:fps=25[v${i}]`);
    } else {
      filters.push(`[${i}:v]format=yuv420p,trim=duration=${duration},fade=t=in:st=0:d=${transitionDuration},zoompan=z='if(lte(zoom,1.0),1.5,max(1.001,zoom-0.0015))':d=1:fps=25,fade=t=out:st=${duration - transitionDuration}:d=${transitionDuration}[v${i}]`);
    }
  }
  
  let concatInputs = "";
  for (let i = 0; i < videoCount; i++) {
    concatInputs += `[v${i}]`;
  }
  filters.push(`${concatInputs}concat=n=${videoCount}:v=1[out]`);
  
  return filters.join(';');
};

// Wipe Transitions
const generateWipeLeftTransition = (videoCount, durations) => {
  return generateWipeTransition(videoCount, durations, "wipeleft");
};

const generateWipeRightTransition = (videoCount, durations) => {
  return generateWipeTransition(videoCount, durations, "wiperight");
};

const generateWipeUpTransition = (videoCount, durations) => {
  return generateWipeTransition(videoCount, durations, "wipeup");
};

const generateWipeDownTransition = (videoCount, durations) => {
  return generateWipeTransition(videoCount, durations, "wipedown");
};

const generateWipeTransition = (videoCount, durations, direction) => {
  let filters = [];
  const transitionDuration = 1.0;
  
  // Base streams
  for (let i = 0; i < videoCount; i++) {
    filters.push(`[${i}:v]format=yuv420p,trim=duration=${durations[i]}[v${i}]`);
  }
  
  // Apply wipe transitions between videos
  for (let i = 0; i < videoCount - 1; i++) {
    const prevEnd = durations.slice(0, i + 1).reduce((a, b) => a + b, 0) - transitionDuration;
    const transitionStart = prevEnd;
    
    filters.push(`[v${i}][v${i + 1}]xfade=transition=${direction}:duration=${transitionDuration}:offset=${transitionStart}[xfade${i}]`);
  }
  
  // Build the final output chain
  if (videoCount === 2) {
    filters.push(`[xfade0]format=yuv420p[out]`);
  } else {
    let xfadeChain = "[xfade0]";
    for (let i = 1; i < videoCount - 1; i++) {
      xfadeChain += `[xfade${i}]`;
    }
    filters.push(`${xfadeChain}concat=n=${videoCount - 1}:v=1[out]`);
  }
  
  return filters.join(';');
};

// Slide Transitions
const generateSlideLeftTransition = (videoCount, durations) => {
  return generateSlideTransition(videoCount, durations, "slideleft");
};

const generateSlideRightTransition = (videoCount, durations) => {
  return generateSlideTransition(videoCount, durations, "slideright");
};

const generateSlideUpTransition = (videoCount, durations) => {
  return generateSlideTransition(videoCount, durations, "slideup");
};

const generateSlideDownTransition = (videoCount, durations) => {
  return generateSlideTransition(videoCount, durations, "slidedown");
};

const generateSlideTransition = (videoCount, durations, direction) => {
  let filters = [];
  const transitionDuration = 1.0;
  
  // Base streams
  for (let i = 0; i < videoCount; i++) {
    filters.push(`[${i}:v]format=yuv420p,trim=duration=${durations[i]}[v${i}]`);
  }
  
  // Apply slide transitions between videos
  for (let i = 0; i < videoCount - 1; i++) {
    const prevEnd = durations.slice(0, i + 1).reduce((a, b) => a + b, 0) - transitionDuration;
    const transitionStart = prevEnd;
    
    filters.push(`[v${i}][v${i + 1}]xfade=transition=${direction}:duration=${transitionDuration}:offset=${transitionStart}[xfade${i}]`);
  }
  
  // Build the final output chain
  if (videoCount === 2) {
    filters.push(`[xfade0]format=yuv420p[out]`);
  } else {
    let xfadeChain = "[xfade0]";
    for (let i = 1; i < videoCount - 1; i++) {
      xfadeChain += `[xfade${i}]`;
    }
    filters.push(`${xfadeChain}concat=n=${videoCount - 1}:v=1[out]`);
  }
  
  return filters.join(';');
};

// Smooth Transitions
const generateSmoothLeftTransition = (videoCount, durations) => {
  return generateSmoothTransition(videoCount, durations, "smoothleft");
};

const generateSmoothRightTransition = (videoCount, durations) => {
  return generateSmoothTransition(videoCount, durations, "smoothright");
};

const generateSmoothUpTransition = (videoCount, durations) => {
  return generateSmoothTransition(videoCount, durations, "smoothup");
};

const generateSmoothDownTransition = (videoCount, durations) => {
  return generateSmoothTransition(videoCount, durations, "smoothdown");
};

const generateSmoothTransition = (videoCount, durations, direction) => {
  let filters = [];
  const transitionDuration = 1.5; // Longer for smooth effect
  
  // Base streams
  for (let i = 0; i < videoCount; i++) {
    filters.push(`[${i}:v]format=yuv420p,trim=duration=${durations[i]}[v${i}]`);
  }
  
  // Apply smooth transitions between videos
  for (let i = 0; i < videoCount - 1; i++) {
    const prevEnd = durations.slice(0, i + 1).reduce((a, b) => a + b, 0) - transitionDuration;
    const transitionStart = prevEnd;
    
    // Use slide transitions for smooth effect with longer duration
    const smoothDirection = direction.replace('smooth', 'slide');
    filters.push(`[v${i}][v${i + 1}]xfade=transition=${smoothDirection}:duration=${transitionDuration}:offset=${transitionStart}[xfade${i}]`);
  }
  
  // Build the final output chain
  if (videoCount === 2) {
    filters.push(`[xfade0]format=yuv420p[out]`);
  } else {
    let xfadeChain = "[xfade0]";
    for (let i = 1; i < videoCount - 1; i++) {
      xfadeChain += `[xfade${i}]`;
    }
    filters.push(`${xfadeChain}concat=n=${videoCount - 1}:v=1[out]`);
  }
  
  return filters.join(';');
};


const generateSimpleConcat = (videoCount) => {
  let inputs = "";
  for (let i = 0; i < videoCount; i++) {
    inputs += `[${i}:v]`;
  }
  return `${inputs}concat=n=${videoCount}:v=1[out]`;
};

const generateSimpleFadeTransition = (videoCount) => {
  if (videoCount === 1) return "[0:v]format=yuv420p[out]";
  
  let filters = [];
  for (let i = 0; i < videoCount; i++) {
    if (i === 0) {
      filters.push(`[${i}:v]format=yuv420p,fade=t=out:st=4.5:d=0.5[v${i}]`);
    } else if (i === videoCount - 1) {
      filters.push(`[${i}:v]format=yuv420p,fade=t=in:st=0:d=0.5[v${i}]`);
    } else {
      filters.push(`[${i}:v]format=yuv420p,fade=t=in:st=0:d=0.5,fade=t=out:st=4.5:d=0.5[v${i}]`);
    }
  }
  
  let concatInputs = "";
  for (let i = 0; i < videoCount; i++) {
    concatInputs += `[v${i}]`;
  }
  filters.push(`${concatInputs}concat=n=${videoCount}:v=1[out]`);
  
  return filters.join(';');
};


// Download video function
const downloadVideo = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Load FFmpeg (your existing function)
const loadFFmpeg = async () => {
  if (ffmpegLoaded && ffmpeg) return ffmpeg;

  ffmpeg = new FFmpeg();
  
  ffmpeg.on('log', ({ type, message }) => {
    console.log(`[ffmpeg ${type}] ${message}`);
  });

  ffmpeg.on('progress', ({ progress, time }) => {
    console.log(`Progress: ${Math.round(progress * 100)}%`);
  });

  const baseURL = "https://unpkg.com/@ffmpeg/core@0.12.6/dist/umd";

  try {
    await ffmpeg.load({
      coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, "text/javascript"),
      wasmURL: await toBlobURL(`${baseURL}/ffmpeg-core.wasm`, "application/wasm"),
    });

    ffmpegLoaded = true;
    console.log("FFmpeg loaded successfully");
    return ffmpeg;
  } catch (error) {
    console.error("Failed to load FFmpeg:", error);
    throw error;
  }
};

// Utility function to convert blob URL to File object
const blobUrlToFile = async (blobUrl) => {
  try {
    // Fetch the blob from the blob URL
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    
    // Create a File object from the blob
    const file = new File([blob], `video-${Date.now()}.mp4`, { type: blob.type });
    return file;
  } catch (error) {
    console.error('Error converting blob URL to file:', error);
    throw error;
  }
};

// Check if URL is a blob URL
const isBlobUrl = (url) => {
  return url.startsWith('blob:');
};

const handleExportClick = async () => {
  try {
    console.log("Starting export with videos:", veo2Videos);
    
    await ExportFinalVideo(
      veo2Videos,
      selectedTransition,
      (progress) => {
        setExportProgress(progress);
        console.log(`Export progress: ${progress}%`);
      }
    );
    
    // alert();
    setOpen(true);
    setContent("Video exported successfully!")
  } catch (error) {
    console.error("Export failed:", error);
    // alert("Export failed: " + error.message);
    setOpen(true);
    setIconType('error')
    setContent("Export failed: " + error.message)
  }
};



  return (
    <>
    <Box
      sx={{
        bgcolor: "#171A2D",
        height: "auto",
        overflow: { xs: "auto", sm: "auto" },
        border:"",
        padding: "34px 34px 34px 4.95rem"
      }}
    >

    {/* Left Panel */}
      
    <LeftPanel activeProvider={activeProvider} onProviderChange={setActiveProvider} />


      {/* Mobile and Tablet Content Wrapper */}
      <Box
        sx={{

          display:"flex",
          flexDirection: "row",
          gap: 2,
          border:"",
          // p: { xs: 2, sm: 0 },
          // pt: { xs: 2, sm: 0 },
          // marginLeft:"4.95rem",
          // marginTop:"20px",
          maxWidth:"100vw"
        }}
      >



        {/* Video Preview Area - Only for Heygen or when Veo2 has videos */}
        {activeProvider === PROVIDERS.HEYGEN ?
        <Paper
          elevation={2}
          sx={{
          
            // width: {
            //   xs: "100%",
            //   sm: activeProvider === PROVIDERS.HEYGEN ? "45vw" : "calc(50vw - 80px)",
            //   md: activeProvider === PROVIDERS.HEYGEN ? "40vw" : "35vw",
            //   lg: activeProvider === PROVIDERS.HEYGEN ? "33vw" : "30vw",
            // },
            maxWidth: "583px",
            maxHeight: "329px",
            // aspectRatio: 16 / 9,
            bgcolor: "#282D51",
            borderRadius: 2,
            display: "flex",
            flexDirection:"row",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            mb: { xs: 2, sm: 0 },
            "&:hover": { bgcolor: "#1e2236", border: "1px solid white" },
          }}
        >

            <Box
              component="img"
              src={
                activeTimelineItem !== -1
                  ? timelineItems[activeTimelineItem].thumbnail
                  : null
              }
              sx={{
                borderRadius: 2,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                // border:"1px solid yellow", 
              }}
            />
        </Paper>
        :
         <Paper
          elevation={2}
          sx={{
            maxWidth: "583px",
            maxHeight: "329px",
            // aspectRatio: 16 / 9,
            bgcolor: "#282D51",
            borderRadius: 2,
            display: "flex",
            flexDirection:"row",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            mb: { xs: 2, sm: 0 },
            // "&:hover": { bgcolor: "#1e2236", border: "1px solid white" },
          }}
        >
        <VideoPreviewWindow activeVideo={activeTimelineItem} veo2Videos={veo2Videos} />
        </Paper>
        }
        

          {/* Right Panel - Only for Heygen */}
        <>
        <Box sx={{ border:"", display:"flex", flexDirection:"row", columnGap:"32px", width:"100%"}}>
        <Box sx={{  border:"", width: { xs: "100%", sm: "100%", md: "100%" }, display:"flex", flexDirection:"column", rowGap:"24px"}}>
        <Box sx={{display:"flex", flexDirection:"row", columnGap:"16px"}}>
          <Typography sx={{  color: "#ffffff", height: 50, display:"flex", alignItems:"center", fontWeight: "bold", fontSize: "15px",}}>
            Title:
          </Typography>
           <Paper
            elevation={2}
            sx={{
              width: { xs: "100%", sm: "100%" },
              height: 50,
              bgcolor: "#1F233E",
              borderRadius: 2.5,
              mb: { xs: 2, sm: 0 },
              mx: { xs: "auto", sm: 0 },
            }}>
            
            <TextField
              fullWidth
              value={videoTitle}
              onChange={(e) => setVideoTitle(e.target.value)}
              placeholder={
                activeProvider === PROVIDERS.HEYGEN
                  ? "Enter title "
                  : "Enter Title"
              }
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: 50,
                  bgcolor: "transparent",
                  color: "#7c7c7c",
                  border: "none",
                  "& fieldset": {
                    border: "none",
                  },
                },
                "& .MuiInputBase-input": {
                  fontSize: 20,
                  fontWeight: "bold",
                  fontFamily: "Jura, sans-serif",
                  px: 2,
                },
              }}
            />
          </Paper>
          </Box>
            <ScriptPanel
            script={script}
            onScriptChange={handleScriptChange}
            onAIEnhance={handleAIEnhance}
            isEnhancing={isEnhancing}
            provider={activeProvider}
            setVeo2Prompt={setVeo2Prompt}
            veo2Prompt={veo2Prompt}
          />
        </Box>
        <Button onClick={handleCancel} sx={{color:"#ffffff",textDecorationLine:"underline", alignItems:"start", height:"30px", bgcolor:""}}>Cancel</Button>
        </Box>
        </>

      </Box>

      
        {/* Script/Prompt Panel - Above Timeline on Left */}
        {/* {activeProvider === PROVIDERS.HEYGEN ? (
        null
        ) : (
         
        )} */}

      {/* Timeline */}
      {activeProvider === PROVIDERS.HEYGEN ? (
          <>
           <RightPanel
            activeTab={activeTab}
            onTabChange={setActiveTab}
            timelineItemss={setTimelineItems}
            items={timelineItems}
            activeTimelineItems={activeTimelineItem}
            caption={caption}
            setCaption={setCaption}
            width={videoWidth}
            setWidth={setVideoWidth}
            height={videoHeight}
            setHeight={setVideoHeight}
          />
        </>
      ) : ( 
        <>
            {/* Veo2 Prompt Panel - Left side above timeline */}
            {/* <ScriptPanel
              script={veo2Prompt}
              onScriptChange={setVeo2Prompt}
              onAIEnhance={handleAIEnhance}
              isEnhancing={isEnhancing}
              provider={activeProvider}
            /> */}

            {/* Veo2 Settings Panel - Top Right */}
            {/* <Paper
              elevation={2}
              sx={{
                // position: { xs: "relative", sm: "absolute" },
                // right: { xs: 0, sm: "10px", md: "20px" },
                // top: { xs: 0, sm: "10px", md: "500px" },
                width: { xs: "100%", sm: "100vw", md: "100%", lg: "100%" },
                maxHeight: {
                  xs: "400px",
                  sm: "55vh",
                  md: "calc(100vh - 280px)",
                },
                bgcolor: "#1F233E",
                borderRadius: 2,
                overflow: "auto",
                mb: { xs: 2, sm: 0 },
                // zIndex: 5,
                marginTop:"32px"
              }}
            >
            </Paper> */}
              <Veo2Settings activeVideo={activeTimelineItem} veo2Videos={veo2Videos} initializeFFmpeg={initializeFFmpeg} selectedTransition={selectedTransition} setSelectedTransition={setSelectedTransition}/>
          </>
        // <Box
        //   sx={{
        //     position: { xs: "fixed", sm: "absolute" },
        //     left: { xs: 0, sm: "60px", md: "3.9rem" },
        //     bottom: { xs: "60px", sm: 0 },
        //     width: {
        //       xs: "100%",
        //       sm: "calc(100vw - 60px)",
        //       md: "calc(100vw - 3.9rem)",
        //     },
        //     zIndex: { xs: 90, sm: "auto" },
        //   }}
        // >
        //   <VideoTimeline
        //     videos={veo2Videos}
        //     onTrim={handleVeo2Trim}
        //     onAddTransition={handleVeo2AddTransition}
        //     onDeleteClip={(index) => {
        //       const updatedVideos = [...veo2Videos];
        //       updatedVideos.splice(index, 1);
        //       setVeo2Videos(updatedVideos);
        //       showSnackbar("Video clip removed", "info");
        //     }}
        //     transitions={veo2Transitions}
        //   />
        //   {ffmpegLoading && (
        //     <Box
        //       sx={{
        //         position: "absolute",
        //         top: 0,
        //         left: 0,
        //         right: 0,
        //         bottom: 0,
        //         bgcolor: "rgba(0, 0, 0, 0.7)",
        //         display: "flex",
        //         flexDirection: "column",
        //         alignItems: "center",
        //         justifyContent: "center",
        //         zIndex: 1000,
        //       }}
        //     >
        //       <CircularProgress size={60} sx={{ color: "#4CAF50" }} />
        //       <Typography sx={{ color: "white", mt: 2 }}>
        //         Processing Video... {Math.round(exportProgress)}%
        //       </Typography>
        //     </Box>
        //   )}
        // </Box>
      )}

    <Box sx={{border:"", position:"relative", display:"flex", flexDirection:"row", height:"auto"}}>

        <Timeline
          timelineItems={activeProvider === PROVIDERS.HEYGEN ? timelineItems : veo2Videos}
          onReorder={handleTimelineReorder}
          onDeleteItem={handleDeleteTimelineItem}
          onAddToTimeline={handleAddToTimeline}
          onClickItem={setActiveTimelineItem}
          activeItem={activeTimelineItem}
          activeProvider={activeProvider}
        />
        <Box>
           {/* Create and Generate Buttons  */}
        <Box
          sx={{
            border:"",
            minWidth:"124px",
            position: { xs: "relative", sm: "absolute" },
            
            left: { xs: 0, sm: '90%' },
            top: { xs: "32px", sm: "32px" },
            display: "flex",
            gap: { xs: 1, sm: 2 },
            flexDirection: "column",
            // justifyContent: { xs: "center", sm: "flex-start" },
            // mb: { xs: 2, sm: 0 },
            // px: { xs: 2, sm: 0 },
            // zIndex: 20,
            marginLeft:"32px"
          }}
        >
          <Button
            variant="contained"
            onClick={
              activeProvider === PROVIDERS.HEYGEN
                ? handleCreate
                : handleVeo2Generate
            }
            disabled={loading || ffmpegLoading}
            sx={{
              color: "rgba(246, 190, 106, 1)",
              fontSize: { xs: 14, md: 16 },
              fontWeight: "bold",
              px: { xs: 2, md: 2 },
              py: { xs: 1, md: 1 },
              minWidth: { xs: "100px", md: "124px" },
              borderRadius: 2,
              border: "1px solid rgba(246, 190, 106, 1)",
                bgcolor: "rgba(40, 45, 81, 1)",
              "&:hover": {
                bgcolor:
                  activeProvider === PROVIDERS.HEYGEN
                    ? "rgba(246,192,111,0.7)"
                    : "rgba(246,192,111,0.7)",
              },
              "&:disabled": {
                opacity: 0.5,
              },
            }}
          >
            {loading
              ? "Generating..."
              : activeProvider === PROVIDERS.HEYGEN
              ? "Create"
              : "Generate"}
          </Button>
          {activeProvider === PROVIDERS.VEO2 && veo2Videos?.length > 0 && (
            <>
            <Button disabled={veo2Videos?.length == 0}
                            onClick={()=>{handleExportClick()}}
                            sx={{
                              width: "100%",
                              height: "40px",
                              textTransform: "none",
                              fontFamily: "Inter",
                              fontSize: "16px",
                              fontWeight: 600,
                              textAlign: "center",
                              color: "rgba(23, 24, 44, 1)",
                              bgcolor: "rgba(246, 190, 107, 1)",
                              minWidth: { xs: "100px", md: "124px" },
                              borderRadius: "8px",
                              "&:hover": {
                                  backgroundColor: "#ffd9aa", 
                              },
                              "&.Mui-disabled": {
                                color: "rgba(230, 224, 233, 1)",
                                bgcolor: "rgba(40, 45, 81, 1)"
                              },
                            }}
                          >
                            Export
              </Button>
            </>
          )}
        </Box>
        </Box>
    </Box>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Confirmation Dialog */}
      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ ...confirmDialog, open: false })}
        PaperProps={{
          sx: {
            bgcolor: "#1F233E",
            color: "white",
            borderRadius: "16px",
            margin:"0px"
          },
        }}
      >
        {/* Title with Close Button */}
        <DialogTitle
          sx={{
            color: "white",
            fontSize: "18px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding:"16px 20px",
            borderBottom:"1px solid rgba(255, 255, 255, 0.10)",
            maxHeight:"60px"
          }}
        >
          {confirmDialog.title}
          <IconButton
            onClick={() => setConfirmDialog({ ...confirmDialog, open: false })}
            sx={{ color: "#ccc" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent   sx={{display:"flex", margin:"20px 25px", padding:"0px"}}>
          <Typography sx={{ color: "#ccc", padding:"0px", fontSize:"14px", }}>
            {confirmDialog.message}
          </Typography>
        </DialogContent>
        <DialogActions sx={{display:"flex",padding:"16px 20px", maxHeight:"72px"}}>
          <Button
            onClick={() => setConfirmDialog({ ...confirmDialog, open: false })}
            sx={{ color: "#ccc" }}
          >
            Cancel
          </Button>
          <Button
              onClick={() => {
                confirmDialog.onConfirm?.();
                setConfirmDialog({ ...confirmDialog, open: false });
              }}
              variant="contained"
              sx={{backgroundColor: button_bg_color_for_New_Project,
                         '&:hover': {
                           backgroundColor:'#FFD9AA',
                         },
                         color:'#17182C',
                         fontSize:'16px',
                         fontWeight:600,
                         textTransform:'none',
                         fontFamily: 'Inter, sans-serif',}}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Video Creation Dialog  */}
      <VideoCreationDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        videoTitle={videoTitle}
        caption={caption}
        Width={videoWidth}
        Height={videoHeight}
        timelineItems={timelineItems}
        onStart={() =>
          showSnackbar(
            "Video creation started! You will be notified when ready.",
            "success"
          )
        }
      />
      <VideoCreationDialogForVeo open={openDialogForVeo} onClose={() => setOpenDialogForVeo(false)} videoTitle={videoTitle} dailogMessage={dailogMessage}/>
        <CommonToast open={open} onClose={handleCloseToast} content={content} iconType={iconType} bgColor={"#373E6D"}/>
    </Box>
    </>
  );
}
